import React, { Component } from 'react';
import Flatpickr from 'react-flatpickr'
import PromptPicker from '../promptPicker';

class CustomMessages extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editData: false,
            filterBy: {},
            sortBy: 'DisplayName',
            sortOrder: 1,
            loading: false,
            type: "special",
            "editMessage": false
        };
    }



    handleTempMessageValueChange = (event, optionCount) => {
        const { value } = event.target;
        const updatedTempMessage = { ...this.state.tempMessage };
        updatedTempMessage.menu[optionCount].transferTo = this.validateAndFormatPhoneNumber(value);
        this.setState({ tempMessage: updatedTempMessage });
    }
    handleTempMessageValueChangeMain = (event, optionCount) => {
        const { value } = event.target;
        const updatedTempMessage = { ...this.state.tempMessage };
        updatedTempMessage.transferTo = this.validateAndFormatPhoneNumber(value);
        this.setState({ tempMessage: updatedTempMessage });
    }

    //Main Edit Functions
    mainToggle = (param) => (e) => {
        //update param to the oppiste of what it is in temp message
        var tempMessage = this.state.tempMessage
        tempMessage[param] = !tempMessage[param]
        this.setState({ tempMessage: tempMessage })

    }
    mainHandleNameEdit = (e) => {
        var tempMessage = this.state.tempMessage
        tempMessage.name = e.target.value
        this.setState({ tempMessage: tempMessage })
    }
    mainHandleProductEdit = (e) => {
        var tempMessage = this.state.tempMessage
        tempMessage.product = e.target.value
        this.setState({ tempMessage: tempMessage })
    }


    //Menu Edit Functions


    //Other
    cancel = () => {
        this.setState({ editMessage: false, tempMessage: false, loading: false, error: '' })
    }
    checkEnter = (e) => {
        if (e.keyCode === 13) {
            this.confirmEdit();
        }
    }
    componentWillReceiveProps(nextProps) {
        if (this.state.loading) {
            this.cancel()
        }
    }




    confirmEdit = () => {
        // Add your logic here to handle confirming the edit
        this.setState({ loading: true })
        var tempMessage = this.state.tempMessage
        tempMessage.creationDate = new Date().toJSON()
        this.props.ws.send(JSON.stringify({ route: 'updateCustomMessages', data: tempMessage }))
        //update state to not be editing
        this.setState({ editMessage: false, loading: false, tempMessage: null })
    }
    deleteMessage = () => {
        // Add your logic here to handle confirming the edit
        this.setState({ loading: true })
        var tempMessage = this.state.tempMessage
        this.props.ws.send(JSON.stringify({ route: 'deleteCustomMessages', data: tempMessage }))
        //update state to not be editing
        this.setState({ editMessage: false, loading: false, tempMessage: null })
    }
    addMessage = () => {
        // Add your logic here to handle confirming the edit
        //Create empty tempMessage
        var tempMessage = {
            "name": "",
            "prompt": "",
            "start": new Date().toJSON(),
            "end": new Date().toJSON(),
            "id": uuidv4(),
            "product": "",
            "barge": true,
            "active": false,
            "menu": [
                {
                    "prompt": "",
                    "actionAfterPlaying": "",
                    "active": false
                },
                {
                    "prompt": "",
                    "actionAfterPlaying": "",
                    "active": false
                },
                {
                    "prompt": "",
                    "actionAfterPlaying": "",
                    "active": false
                },
                {
                    "prompt": "",
                    "actionAfterPlaying": "",
                    "active": false
                }
            ]
        }
        this.setState({ editMessage: true, loading: false, tempMessage: tempMessage, error: '' })
    }
    sort = (sortBy) => (e) => {
        var sortOrder
        if (this.state.sortOrder === -1) {
            sortOrder = 1;
        } else {
            sortOrder = -1;
        }
        this.setState({ sortBy: sortBy, sortOrder: sortOrder })
    }
    filter = (field) => (e) => {
        var filterBy = this.state.filterBy
        if (e.target.value.length > 0) {
            filterBy[field] = e.target.value
        } else {
            delete filterBy[field]
        }
        this.setState({ filterBy: filterBy })
    }
    sortFunc(sortBy, sortOrder) {
        return function (a, b) {

            if (sortBy in a && sortBy in b) {
                if (a[sortBy] === b[sortBy]) {
                    return a.DisplayName > b.DisplayName ? 1 * sortOrder : -1 * sortOrder
                }
                return a[sortBy] > b[sortBy] ? 1 * sortOrder : -1 * sortOrder
            }
        }
    }
    checkType = (e) => {
        console.log(e.target.value)
        this.setState({ type: e.target.value })
    }
    filterFunc(array, filterBy) {
        return array.filter(function (object) {
            for (var prop in filterBy) {
                if (typeof object[prop] === "undefined") {
                    return false
                }
                if (prop === 'language') {
                    if (object[prop].indexOf(filterBy[prop]) < 0) {
                        return false
                    }

                } else {
                    if (object[prop].toString().toLowerCase().indexOf(filterBy[prop].toString().toLowerCase()) < 0) {
                        return false
                    }
                }

            }
            return true
        })
    }
    filterIcon(item) {
        return (this.state.sortBy === item ? (this.state.sortOrder == 1) ? " \u25B2" : " \u25BC" : "")
    }
    editMessage = (ID) => (e) => {
        var message = JSON.parse(JSON.stringify(this.props.data.CustomMessages.data.find(function (element) {
            return element.id === ID;
        })))
        var newState = { editMessage: true, loading: false, tempMessage: message, error: '' }
        this.setState(newState)
    }
    mainPromptChange = (value) => {
        //update the prompt of the tempMessage

        var tempMessage = this.state.tempMessage
        tempMessage.prompt = value
        this.setState({ tempMessage: tempMessage })
    }
    menuPromptChange = (optionIndex, value) => {
        var tempMessage = this.state.tempMessage;
        tempMessage.menu[optionIndex].prompt = value;
        this.setState({ tempMessage: tempMessage });
    }
    filterByDropdown = (value) => {
        var filterBy = this.state.filterBy
        if (!value) {
            delete filterBy.is_enabled
        } else if (value.id == 1) {
            filterBy.is_enabled = true
        } else if (value.id == 0) {
            filterBy.is_enabled = false
        }
        this.setState({ filterBy: filterBy })

    }
    toggleMenuCheckbox(optionIndex) {
        let tempMessage = { ...this.state.tempMessage };
        tempMessage.menu[optionIndex].active = !tempMessage.menu[optionIndex].active;
        this.setState({ tempMessage });
    }
    handleSelectChange(optionIndex, event) {
        let tempMessage = { ...this.state.tempMessage };
        tempMessage.menu[optionIndex].actionAfterPlaying = event.target.value;
        this.setState({ tempMessage });
    }
    handleSelectChangeMain(event) {
        let tempMessage = { ...this.state.tempMessage };
        tempMessage.actionAfterPlaying = event.target.value;
        this.setState({ tempMessage });
    }
    // Function to validate and format phone number
    validateAndFormatPhoneNumber = (input) => {
        const phoneNumber = input.replace(/\D/g, ''); // Remove non-numeric characters
        if (phoneNumber.length === 10) {
            const formattedPhoneNumber = `+1${phoneNumber}`;
            return formattedPhoneNumber;
        }
        return input; // Return the original input if it doesn't match the format
    }
    render() {
        if (this.props.active) {
            // if (this.state.type === "" || this.state.type === undefined) {
            //     this.setState({ type: "user" })
            // }


            var messageList = []
            var CustomMessages = JSON.parse(JSON.stringify(this.props.data.CustomMessages.data));
            var Prompts = JSON.parse(JSON.stringify(this.props.data.Prompts));



            // //Filtering List
            if (Object.keys(this.state.filterBy).length > 0) {
                CustomMessages = this.filterFunc(CustomMessages, this.state.filterBy)
            }
            // //Sorting List
            if (this.state.sortBy !== '') {
                CustomMessages.sort(this.sortFunc(this.state.sortBy, this.state.sortOrder))
            }

            for (var message of CustomMessages) {


                messageList.push(
                    <tr className="dataRow" onClick={this.editMessage(message.id)} key={prompt.id}>
                        <td style={{ flex: '1 0 180px', textAlign: 'left' }}>{message.name}</td>
                        <td style={{ minWidth: '100px', textAlign: 'left', display: 'flex', alignItems: 'center' }}>
                            {message.active ?
                                <div style={{
                                    backgroundColor: '#2A6AA9',
                                    color: 'white',
                                    borderRadius: '50%',
                                    height: '20px',
                                    width: '20px',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                }}>
                                    <svg width="10" height="8" viewBox="0 0 10 8">
                                        <path fill="currentColor" d="M10 1.5L3.5 8L0 4.5L1.5 3L3.5 5L8.5 0L10 1.5Z"></path>
                                    </svg>
                                </div>
                                : null
                            }
                        </td>
                        <td style={{ flex: '0 0 250px', textAlign: 'left' }}>
                            {new Date(message.start).toLocaleString('en-US', {
                                month: 'short',
                                day: 'numeric',
                                year: 'numeric',
                                hour: 'numeric',
                                minute: 'numeric',
                                hour12: true
                            })}
                        </td>
                        <td style={{ flex: '0 0 250px', textAlign: 'left' }}>
                            {new Date(message.end).toLocaleString('en-US', {
                                month: 'short',
                                day: 'numeric',
                                year: 'numeric',
                                hour: 'numeric',
                                minute: 'numeric',
                                hour12: true
                            })}
                        </td>
                    </tr>
                );

            }
            var editMessage = ""
            if (this.state.editMessage) {

                var menuOptions = []
                var optionTotal = this.state.tempMessage.menu.length

                for (let optionCount = 0; optionCount < optionTotal; optionCount++) {
                    menuOptions.push(
                        <div style={{ backgroundColor: '#f2f2f2', padding: '3px', borderRadius: '5px', display: 'flex', alignItems: 'center', justifyContent: "center", marginBottom: "8px" }}>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                                    <h3 style={{ marginRight: '10px' }}>Menu Option {optionCount + 1}</h3>
                                    <div className="activeBox" style={{ position: "static" }} onClick={() => { this.toggleMenuCheckbox(optionCount) }}>
                                        <div className={this.state.tempMessage.menu[optionCount].active ? "enabled" : "disabled"} style={{ position: "static", zIndex: "1" }}></div>                                    </div>
                                </div>

                                {this.state.tempMessage.menu[optionCount].active && (
                                    <div style={{ display: 'flex', flexDirection: 'column', padding: '10px', borderRadius: '8px' }}>
                                        <PromptPicker prompts={Prompts} currentPrompt={this.state.tempMessage.menu[optionCount].prompt} selectionChange={(value) => this.menuPromptChange(optionCount, value)} ws={this.props.ws} />

                                        <div style={{ alignItems: 'center', marginBottom: '10px' }}>
                                            <label style={{ marginRight: "10px", fontSize: "12" }}>Action After Playing</label>
                                            <select
                                                style={{
                                                    width: '150px',
                                                    padding: '8px',
                                                    borderRadius: '4px',
                                                    border: '1px solid #2A6AA9',
                                                    marginBottom: '10px',
                                                    backgroundColor: '#ffffff',
                                                    marginRight: '10px'
                                                }}
                                                value={this.state.tempMessage.menu[optionCount].actionAfterPlaying}
                                                onChange={(event) => { this.handleSelectChange(optionCount, event) }}
                                            >

                                                <option value="continue">Continue</option>
                                                <option value="transfer">Transfer</option>
                                                <option value="disconnect">Disconnect</option>
                                                <option value="voicemail">Voicemail</option>
                                            </select>
                                        </div>
                                        {this.state.tempMessage.menu[optionCount].actionAfterPlaying === "transfer" && (
                                            <div style={{ alignItems: 'center', marginBottom: '10px' }}>
                                                <label style={{ marginRight: "10px", fontSize: "12" }}>Transfer To</label>
                                                {/*Text Box to enter phone number*/}
                                                <input

                                                    style={{
                                                        width: '150px',
                                                        padding: '8px',
                                                        borderRadius: '4px',
                                                        border: '1px solid #2A6AA9',
                                                        marginBottom: '10px',
                                                        backgroundColor: '#ffffff',
                                                        marginRight: '10px'
                                                    }}
                                                    type="text"
                                                    value={this.state.tempMessage.menu[optionCount].transferTo}
                                                    onChange={(event) => { this.handleTempMessageValueChange(event, optionCount) }}
                                                />
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    )
                }
                editMessage = (
                    <div className="blackout" tabIndex="1" autoFocus onKeyUp={this.checkEnter}>
                        <div className="pop" style={{ overflow: "" }}>
                            <div className="viewCloser" onClick={this.cancel}></div>
                            {
                                !this.state.tempMessage.permanent ? (
                                    <div className="snazzyInputBox">
                                        <input className="textInput" type="text" required value={this.state.tempMessage.name} onChange={this.mainHandleNameEdit} ></input>
                                        <span className="inputBar"></span>
                                        <label className="textLabel">Name</label>
                                    </div>
                                ) : (
                                    <h2>{this.state.tempMessage.name}</h2>
                                )
                            }
                            {
                                !this.state.tempMessage.permanent ? (
                                    <div className="snazzyInputBox">
                                        <input className="textInput" type="text" required value={this.state.tempMessage.product} onChange={this.mainHandleProductEdit} ></input>
                                        <span className="inputBar"></span>
                                        <label className="textLabel">productInternalName</label>
                                    </div>
                                ) : null
                            }
                            {/* Dropdown using promptNames array */}

                            <PromptPicker prompts={Prompts} currentPrompt={this.state.tempMessage.prompt} selectionChange={this.mainPromptChange} ws={this.props.ws} />

                            <div style={{ display: 'inline-block' }}>
                                <div>Start</div>
                                <Flatpickr
                                    style={{ border: '1px solid #2A6AA9', padding: '15px', width: '130px', margin: '5px' }}
                                    options={{ dateFormat: "Y-m-d h:i K" }}
                                    data-enable-time
                                    value={this.state.tempMessage.start}
                                    onChange={date => {
                                        date[0] ? this.setState(prevState => ({
                                            tempMessage: {
                                                ...prevState.tempMessage,
                                                start: date[0]
                                            }
                                        })) : this.setState(prevState => ({
                                            tempMessage: {
                                                ...prevState.tempMessage,
                                                start: undefined
                                            }
                                        }))
                                    }}
                                />
                            </div>
                            <div style={{ display: 'inline-block' }}>
                                <div>End</div>
                                <Flatpickr
                                    style={{ border: '1px solid #2A6AA9', padding: '15px', width: '130px', margin: '5px' }}
                                    options={{ dateFormat: "Y-m-d h:i K" }}
                                    data-enable-time
                                    value={this.state.tempMessage.end}
                                    onChange={date => {
                                        date[0] ? this.setState(prevState => ({
                                            tempMessage: {
                                                ...prevState.tempMessage,
                                                end: date[0]
                                            }
                                        })) : this.setState(prevState => ({
                                            tempMessage: {
                                                ...prevState.tempMessage,
                                                end: undefined
                                            }
                                        }))
                                    }}
                                />
                            </div>




                            <div style={{ paddingTop: '25px', display: 'flex', justifyContent: 'space-around' }}>
                                <div >
                                    <div>Active</div>
                                    <div className="activeBox" style={{ position: "static" }} onClick={this.mainToggle('active')}>
                                        <div className={this.state.tempMessage.active ? "enabled" : "disabled"} style={{ position: "static", "z-index": "1" }}></div>
                                    </div>
                                </div>
                                <div >
                                    <div>Allow Barge</div>
                                    <div className="activeBox" style={{ position: "static" }} onClick={this.mainToggle('barge')}>
                                        <div className={this.state.tempMessage.barge ? "enabled" : "disabled"} style={{ position: "static" }}></div>
                                    </div>
                                </div>
                            </div>
                            <div style={{ alignItems: 'center', marginBottom: '10px' }}>
                                <label style={{ marginRight: "10px", fontSize: "12" }}>Action After Playing</label>
                                <select
                                    style={{
                                        width: '150px',
                                        padding: '8px',
                                        borderRadius: '4px',
                                        border: '1px solid #2A6AA9',
                                        marginBottom: '10px',
                                        backgroundColor: '#ffffff',
                                        marginRight: '10px'
                                    }}
                                    value={this.state.tempMessage.actionAfterPlaying}
                                    onChange={(event) => { this.handleSelectChangeMain(event) }}
                                >

                                    <option value="continue">Continue</option>
                                    <option value="transfer">Transfer</option>
                                    <option value="disconnect">Disconnect</option>
                                    <option value="voicemail">Voicemail</option>
                                </select>
                            </div>
                            {this.state.tempMessage.actionAfterPlaying === "transfer" && (
                                <div style={{ alignItems: 'center', marginBottom: '10px' }}>
                                    <label style={{ marginRight: "10px", fontSize: "12" }}>Transfer To</label>
                                    {/*Text Box to enter phone number*/}
                                    <input

                                        style={{
                                            width: '150px',
                                            padding: '8px',
                                            borderRadius: '4px',
                                            border: '1px solid #2A6AA9',
                                            marginBottom: '10px',
                                            backgroundColor: '#ffffff',
                                            marginRight: '10px'
                                        }}
                                        type="text"
                                        value={this.state.tempMessage.transferTo}
                                        onChange={(event) => { this.handleTempMessageValueChangeMain(event) }}
                                    />
                                </div>
                            )}
                            {menuOptions}
                            <div className="error" style={{ padding: '15px' }}>{this.state.error}</div>
                            {this.state.loading ? <div className="loader"></div> : <div className="button" onClick={this.confirmEdit}>Confirm Message</div>}
                            {/*Delete Button with style to make it red*/}
                            <div style={{ paddingTop: '25px', display: 'flex', justifyContent: 'space-around' }}></div>
                            {!this.state.tempMessage.permanent && <div className="button" style={{ backgroundColor: "Red" }} onClick={this.deleteMessage}>Delete Message</div>}
                            <div style={{ paddingTop: '25px', display: 'flex', justifyContent: 'space-around' }}></div>

                        </div>
                    </div>
                )
            }

            var addButton = ""
            //addButton = <img src={this.props.img.plus} className="plusButton" alt="Add a Domain" onClick={this.addMessage} />
            return (
                <div width="100%">
                    {addButton}
                    <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                        <div style={{ width: '200px', marginRight: '10px', marginTop: '2px' }}>
                            <div className="filterBox" style={{
                                "width": "210px"
                            }}>
                                <h4>Filter By:</h4>
                                <div style={{ width: '150px' }}>
                                    <label>Name:</label>
                                    <input type="text" onChange={this.filter("name")} value={this.state.filterBy.DisplayName} />
                                </div>
                            </div>
                        </div>
                        <div style={{ flex: 1 }}>
                            <table style={{ float: "right" }}>
                                <thead>
                                    <tr className="dataRow">
                                        <th style={{ minWidth: '220px', cursor: 'pointer', textAlign: 'left' }} onClick={this.sort("name")}>Name {this.filterIcon("name")}</th>
                                        <th style={{ minWidth: '100px', cursor: 'pointer', textAlign: 'left' }} onClick={this.sort("active")}>Active {this.filterIcon("active")}</th>
                                        <th style={{ minWidth: '250px', cursor: 'pointer', textAlign: 'left' }} onClick={this.sort("start")}>Start {this.filterIcon("start")}</th>
                                        <th style={{ minWidth: '250px', cursor: 'pointer', textAlign: 'left' }} onClick={this.sort("end")}>End {this.filterIcon("end")}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {messageList}
                                </tbody>
                            </table>
                        </div>
                    </div >
                    {editMessage}
                </div >
            );
        } else {
            return (
                <div width="100%">

                </div>
            );
        }
    }
}

function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        // eslint-disable-next-line
        var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
        // eslint-disable-next-line
        return v.toString(16);
    });
};

const icon = "menuWorkflow"
const roles = ["View"]
export { CustomMessages, icon, roles }

